import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useScreenSize } from '../../../../hooks/useScreenSize';
import { ResponseGraphics as Graphics } from '../../../../models/common-payments';
import { AmountsBarGraph } from '../amount-graphic';
import { BanksPieChart } from '../banks-pie-chart';
import { GraphicsAmount, GraphicsAmountMeans, Product } from '../information-graphics';
import { InformationCard } from '../information-graphics/styles';
import {
	HeaderContainer,
	SectionContainer,
	SectionContent,
	SectionDate,
	SectionHeader,
	SectionTitle,
} from './styles';

interface QuickTransferHeaderProps {
	data?: Graphics;
	loading?: boolean;
	countryMX?: boolean;
}

const QuickTransferHeader = ({ data, loading, countryMX }: QuickTransferHeaderProps) => {
	const { width } = useScreenSize();

	const [showCard, setShowCard] = useState({ countryMX, hasCash: false });
	const [totalAmount, setTotalAmount] = useState<string>("0")

	const [sortedData, setSortedData] = useState<{ value: number; time: string }[]>([]);
	const [paymentMethodsData, setPaymentMethodsData] = useState<Product[]>();

	const { colors } = useTheme();
	const COLORS = [colors.extra.sword, '#FF9191', '#FFACAD', '#FFC8C8', '#FFF1F1', '#a648f9'];

	useEffect(() => {
		if (!data || !data.amounts || data.amounts.length === 0) return;

		if (data.hasCash) {
			setShowCard({ ...showCard, hasCash: data.hasCash });
		}

		const formattedData = data.amounts.map(({ y, x_formatted }) => ({ value: Number(y), time: x_formatted }));
		setPaymentMethodsData(data.paymentMethods)
		setTotalAmount(data.totalAmount || "$0")
		setSortedData(formattedData);
	}, [data]);

	return (
		<>
			<div style={{ width: "100%" }}>
				<HeaderContainer>
					{showCard.countryMX && <div>
						<InformationCard>
							<GraphicsAmount data={sortedData} totalAmount={totalAmount} />
						</InformationCard>
					</div>}
					{!showCard.countryMX && width > 576 && <div>
						<SectionContainer>
							<SectionHeader>
								<SectionTitle>Monto recaudado</SectionTitle>
								<SectionDate>Últimas 24 horas</SectionDate>
							</SectionHeader>

							<SectionContent>
								<AmountsBarGraph data={data?.amounts} barColor="#FF9191" tooltipColor="#e8e7eb" />
							</SectionContent>
						</SectionContainer>
					</div>}
					
					{((!showCard.countryMX && width > 576) || (showCard.countryMX && !showCard.hasCash)) && <div>
						<SectionContainer>
							<SectionHeader>
								<SectionTitle>Cobros exitosos por banco</SectionTitle>
								<SectionDate>Últimas 24 horas</SectionDate>
							</SectionHeader>

							<SectionContent>
								<BanksPieChart data={data} colors={COLORS} tooltipColor="#e8e7eb" loading={loading} />
							</SectionContent>
						</SectionContainer>
					</div>}
					{showCard.countryMX && showCard.hasCash && <div>
						<InformationCard>
							<GraphicsAmountMeans data={paymentMethodsData} totalAmount={totalAmount} />
						</InformationCard>
					</div>}

				</HeaderContainer>
			</div>
		</>
	);
};

export { QuickTransferHeader };
